import loadable from '@loadable/component';

export * from './workflowPage';
export * from './workflowInstancePage';
export * from './extensions';
export * from './components';
export * from './modules';
export * from './contexts';
export * from './utils';

const workflowComponentsChunk = () =>
  import(
    /* webpackChunkName: "workflow-shared-components" */ './components.chunk'
  );

export { WorkflowInstanceState } from './components/WorkflowInstanceState/WorkflowInstanceState';

export const StatusIndicator = loadable(() =>
  workflowComponentsChunk().then(m => m.StatusIndicator),
);

export {
  ActionButtonsList,
  ActionButton,
} from './workflowInstancePage/ActionButton';

export const CheckAlerts = loadable(() =>
  workflowComponentsChunk().then(m => m.CheckAlerts),
);
export const BackLink = loadable(() =>
  workflowComponentsChunk().then(m => m.BackLink),
);
export { StatusSidebarSection } from './workflowInstancePage/StatusSidebarSection';

export { EditInstanceNameButton } from './workflowInstancePage/EditInstanceNameButton';

export const WorkflowInstanceTableRow = loadable(() =>
  workflowComponentsChunk().then(m => m.WorkflowInstanceTableRow),
);
export const WorkflowInstanceNameCell = loadable(() =>
  workflowComponentsChunk().then(m => m.WorkflowInstanceNameCell),
);
export const WorkflowInstanceStateCell = loadable(() =>
  workflowComponentsChunk().then(m => m.WorkflowInstanceStateCell),
);
